import { camelCase, mapKeys, snakeCase } from 'lodash';

const removeProperty = (key, obj) => {
  if (!key || !obj) return;
  if (typeof obj === 'object') {
    delete obj[key];
    Object.keys(obj).forEach(x => ObjectUtils.removeProperty(key, obj[x]));
  } else if (Array.isArray(obj)) {
    obj.forEach(val => ObjectUtils.removeProperty(key, val));
  }
};

const deepCamelizeKeys = <T>(obj: T): T => {
  if (!obj || obj instanceof Date || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((element: any) => deepCamelizeKeys(element)) as any;
  }

  const res: Record<string, any> = {};
  for (const [k, v] of Object.entries(obj)) {
    res[camelCase(k)] = deepCamelizeKeys(v);
  }
  return res as any;
};

const mapObjKeysToSnakeCase = (obj: Record<string, any>) => {
  return mapKeys(obj, (_, key) => snakeCase(key));
};

const deepSnakeKeys = (
  obj: Record<string, any>,
  onlyKeys?: boolean,
  upperKeys?: boolean,
): any => {
  if (!obj || obj instanceof Date || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((element: any) => deepSnakeKeys(element));
  }

  const res: any = {};
  for (const [k, v] of Object.entries(obj)) {
    res[!upperKeys ? snakeCase(k) : snakeCase(k).toUpperCase()] = onlyKeys
      ? v
      : deepSnakeKeys(v);
  }
  return res;
};

const ObjectUtils = {
  removeProperty,
  deepCamelizeKeys,
  mapObjKeysToSnakeCase,
  deepSnakeKeys,
};

export default ObjectUtils;
